module.exports = __webpack_public_path__ + "static/img/bg-overview@w.56529a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/hos/bg-overview@w.jpg
// module id = HepB
// module chunks = 0